// =====================================
// NO EDITAR ESTE ARCHIVO DIRECTO
// COMPILADO 2026-05-11 18:29:26
// =====================================

enum ReportsAccess{
	VIEW_STATS = 1, // Ver estadisticas
	VIEW_INCOME = 2, // Ver ingresos
	VIEW_TICKET_USES = 3, // Ver accesos
	VIEW_SEATMAP = 4, // Ver butacas
	VIEW_PAYOUTS = 50, // Ver liquidaciones
	DOWNLOAD_REPORTS = 100, // Descargar reportes
}

export default ReportsAccess;